/// <reference types="google.maps" />
import { Component, ElementRef, EventEmitter, Input, NgZone, OnInit, Output, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { GoogleAddress, GoogleAddressComponent } from 'app/shared/models/domain/data-extra.model';
import { MatFormField, MatLabel, MatInput, MatInputModule } from '@angular/material/input';


import { MatFormFieldModule } from '@angular/material/form-field';
@Component({
    selector: 'map-location',
    templateUrl: './map-location.component.html',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatFormField, MatLabel, MatInput, MatFormFieldModule, MatInputModule]
})
export class MapLocationComponent extends FieldType implements OnInit {
    @ViewChild('search') searchElementRef: ElementRef;
    @Input() mapVisible: boolean = false;
    @Input() showAddress: boolean = false;
    @Output() fetchAddress: EventEmitter<any> = new EventEmitter<any>();
    title: string = 'AGM project';
    latitude: number;
    longitude: number;
    zoom: number;
    address: string;
    webSite: string;
    name: string;
    zipCode: string;
    private geoCoder;
    private googleAddress: GoogleAddress = {};


    constructor(
        //private mapsAPILoader: MapsAPILoader,
        private ngZone: NgZone,

    ) {
        super();
    }

    ngOnInit(): void {
        //load Places Autocomplete
        // this.mapsAPILoader.load().then(() => {
        //     this.setCurrentLocation();
        //     this.geoCoder = new google.maps.Geocoder;
        //     let autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement);
        //     autocomplete.addListener("place_changed", () => {
        //         this.ngZone.run(() => {
        //             //get the place result
        //             let place: google.maps.places.PlaceResult = autocomplete.getPlace();

        //             //verify result
        //             if (place.geometry === undefined || place.geometry === null) {
        //                 return;
        //             }

        //             //set latitude, longitude and zoom
        //             this.latitude = place.geometry.location.lat();
        //             this.longitude = place.geometry.location.lng();
        //             this.zoom = 12;
        //             var parsedAddress = this.parseAddress(place.address_components);
        //             place['parsedAddress'] = parsedAddress;
        //             this.fetchAddress.emit(place);
        //         });
        //     });
        // });
    }

    markerDragEnd($event: any): any {
        this.latitude = $event.coords.lat;
        this.longitude = $event.coords.lng;
        this.getAddress(this.latitude, this.longitude);
    }

    getAddress(latitude, longitude): any {
        this.geoCoder.geocode({ 'location': { lat: latitude, lng: longitude } }, (results, status) => {
            if (status === 'OK') {
                if (results[0]) {
                    this.zoom = 12;
                    this.address = results[0].formatted_address;
                } else {
                    window.alert('No results found');
                }
            } else {
                window.alert('Geocoder failed due to: ' + status);
            }

        });
    }

    saveLocation(): any {
        const data = {
            address: this.address,
            latitude: this.latitude,
            longitude: this.longitude
        };
    }


    findAdress(): any {
        // this.mapsAPILoader.load().then(() => {
        //     let autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement);
        //     autocomplete.addListener('place_changed', () => {
        //         this.ngZone.run(() => {
        //             // some details
        //             let place: google.maps.places.PlaceResult = autocomplete.getPlace();
        //             this.address = place.formatted_address;
        //             this.webSite = place.website;
        //             this.name = place.name;
        //             this.zipCode = place.address_components[place.address_components.length - 1].long_name;
        //             //set latitude, longitude and zoom
        //             this.latitude = place.geometry.location.lat();
        //             this.longitude = place.geometry.location.lng();
        //             this.zoom = 12;
        //             var parsedAddress = this.parseAddress(place.address_components);
        //             place['parsedAddress'] = parsedAddress;
        //             this.fetchAddress.emit(place);
        //         });
        //     });
        // });
    }

    parseAddress(address): any {
        if (!Array.isArray(address)) {
            throw Error('Address Components is not an array');
        }

        if (!address.length) {
            throw Error('Address Components is empty');
        }

        for (let i = 0; i < address.length; i++) {
            const component: GoogleAddressComponent = address[i];

            if (this.isStreetNumber(component)) {
                this.googleAddress.street_number = component.long_name;
            }

            if (this.isStreetName(component)) {
                this.googleAddress.street_name = component.long_name;
            }

            if (this.isCity(component)) {
                this.googleAddress.city = component.long_name;
            }

            if (this.isCountry(component)) {
                this.googleAddress.country = component.long_name;
            }

            if (this.isState(component)) {
                this.googleAddress.state = component.long_name;
            }

            if (this.isPostalCode(component)) {
                this.googleAddress.postal_code = component.long_name;
            }
        }
        return this.googleAddress;
    }

    // Get Current Location Coordinates
    private setCurrentLocation(): any {
        if ('geolocation' in navigator) {
            navigator.geolocation.getCurrentPosition((position) => {
                this.latitude = position.coords.latitude;
                this.longitude = position.coords.longitude;
                this.zoom = 8;
                this.getAddress(this.latitude, this.longitude);
            });
        }
    }

    private isStreetNumber(component: GoogleAddressComponent): boolean {
        return component.types.includes('street_number');
    }

    private isStreetName(component: GoogleAddressComponent): boolean {
        return component.types.includes('route');
    }

    private isCity(component): boolean {
        return component.types.includes('locality');
    }

    private isState(component): boolean {
        return component.types.includes('administrative_area_level_1');
    }

    private isCountry(component): boolean {
        return component.types.includes('country');
    }

    private isPostalCode(component): boolean {
        return component.types.includes('postal_code');
    }


}
